module.exports = __webpack_public_path__ + "static/media/Cunning.10d57d61.svg";